import { render, staticRenderFns } from "./created.vue?vue&type=template&id=6fb0bedc&"
import script from "./created.vue?vue&type=script&lang=js&"
export * from "./created.vue?vue&type=script&lang=js&"
import style0 from "./created.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports